export const objectValueConverter = (obj) => {
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, +value]));
};

export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};
